import React from 'react';
import { Heart, Users, Award } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const About = () => {
  return (
    <div className="min-h-screen vibrant-gradient-bg py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl font-black text-gray-900 mb-4">
            Rólunk
          </h1>
          <p className="text-2xl text-gray-800 italic font-semibold mb-4 drop-shadow-sm">
            "{restaurantInfo.tagline}"
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets.emergentagent.com/job_5db5e26f-1718-47ba-8329-c17dba22ad5b/artifacts/2q6h4h5w_K%C3%A9perny%C5%91k%C3%A9p%202026-03-12%20111822.png"
              alt="Boldog Büfé"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text */}
          <div className="space-y-6">
            <h2 className="text-4xl font-black text-gray-900">
              Boldog Büfé – Szigethalom <span className="text-[#00BCD4]">Szíve</span>
            </h2>
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>
                A <strong className="text-[#FFA726]">Boldog Büfé</strong> egy szeretett helyi büfé Szigethalmon, 
                ahol autentikus magyar retro street food-ot szolgálunk fel.
              </p>
              <p>
                Vendégeink imádják <strong className="text-[#FFA726]">friss felhős lángosainkat</strong>, 
                a <strong className="text-[#FFA726]">retro hamburgerjeinket</strong> és 
                <strong className="text-[#FFA726]"> házi jellegű sült kolbászunkat</strong>.
              </p>
              <p>
                A hangsúly az <strong className="text-[#00BCD4]">egyszerű, finom ételeken</strong>, 
                a <strong className="text-[#00BCD4]">barátságos kiszolgáláson</strong> és 
                a <strong className="text-[#00BCD4]">megfizethető árakon</strong> van.
              </p>
              <p>
                Nálunk minden falat egy kis <strong className="text-[#FFA726]">boldogságot</strong> jelent!
              </p>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="mb-16">
          <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
            Miért válassz <span className="text-[#FFA726]">minket?</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Quality */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#FFA726] to-[#FF9800] rounded-full mb-6">
                <Award className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Minőségi Alapanyagok
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Csak friss, minőségi hozzávalókat használunk. Az ízek klasszikusak, 
                de mindig tökéletesen elkészítve.
              </p>
            </div>

            {/* Tradition */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#00BCD4] to-[#00ACC1] rounded-full mb-6">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Retro Magyar Ízek
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Klasszikus magyar street food élmény – lángos, hamburger, hot-dog 
                azzal a retro, nosztalgikus hangulattal.
              </p>
            </div>

            {/* Service */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#FFA726] to-[#FF9800] rounded-full mb-6">
                <Users className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Barátságos Kiszolgálás
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Vendégeink elégedettsége a legfontosabb. Gyors, kedves kiszolgálás 
                minden alkalommal!
              </p>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-[#00BCD4] to-[#FFA726] rounded-3xl p-12 text-white mb-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-5xl font-black mb-2">{restaurantInfo.rating}</p>
              <p className="text-xl">Google Értékelés</p>
              <p className="text-white/80 text-sm mt-1">{restaurantInfo.reviewCount} vélemény alapján</p>
            </div>
            <div>
              <p className="text-5xl font-black mb-2">100%</p>
              <p className="text-xl">Friss Alapanyagok</p>
              <p className="text-white/80 text-sm mt-1">Minőség a középpontban</p>
            </div>
            <div>
              <p className="text-5xl font-black mb-2">10+</p>
              <p className="text-xl">Év Tapasztalat</p>
              <p className="text-white/80 text-sm mt-1">Helyi street food szakértők</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-br from-gray-50 to-white rounded-2xl p-12 border border-gray-200">
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4">
            Gyere és kóstold meg!
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Látogass el hozzánk, vagy rendelj házhoz!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/menu"
              className="inline-block px-8 py-4 bg-gradient-to-r from-[#00BCD4] to-[#00ACC1] text-white rounded-xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              Étlap és Rendelés
            </a>
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-gradient-to-r from-[#FFA726] to-[#FF9800] text-white rounded-xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              Kapcsolat
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
